import { render, staticRenderFns } from "./CurrentOffer.vue?vue&type=template&id=68f194ba&scoped=true&"
import script from "./CurrentOffer.vue?vue&type=script&lang=js&"
export * from "./CurrentOffer.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOffer.vue?vue&type=style&index=0&id=68f194ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f194ba",
  null
  
)

export default component.exports